var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6C4 5.44772 4.44772 5 5 5L19 5C19.5523 5 20 5.44772 20 6C20 6.55229 19.5523 7 19 7L5 7C4.44772 7 4 6.55228 4 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0983 20.546C8.9582 20.0118 9.2777 19.4651 9.81192 19.325L13.6811 18.3104C14.2153 18.1703 14.7619 18.4898 14.902 19.024C15.0421 19.5582 14.7226 20.1048 14.1884 20.2449L10.3193 21.2596C9.78504 21.3997 9.2384 21.0802 9.0983 20.546Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 17.9965C10.5533 17.9635 11.0019 17.4907 11.0019 16.9404L11.0019 11.5944L5.7863 5.33571C5.44342 4.92424 4.81346 4.88812 4.37924 5.25503C3.94503 5.62194 3.87099 6.25294 4.21387 6.6644L8.99827 12.4057L8.99827 17.0597C8.99827 17.61 9.44679 18.0294 10.0001 17.9965ZM14.0001 16.9965C14.5534 16.9635 15.0019 16.4907 15.0019 15.9404L15.0019 12.3139L19.7551 6.61002C20.1187 6.17363 20.0755 5.54677 19.6586 5.2099C19.2416 4.87302 18.6088 4.95369 18.2451 5.39008L12.9983 11.6863L12.9983 16.0597C12.9983 16.61 13.4469 17.0294 14.0001 16.9965Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.3b7e54525a87d75a13b5e9c009e08c7d.svg";
export { ForwardRef as ReactComponent };